import { Option } from "@intentsify/types";

export type DisplayPerformanceFilters = {
  yearFrom: number;
  weekFrom: number;
  yearTo: number;
  weekTo: number;
};

export type CampaignOption = Option<number | string> & {
  companyId: number | string;
};

export enum DisplayPerformanceView {
  CampaignEngagement = "campaign-engagement",
  Accounts = "accounts",
  CreativeEngagement = "creative-engagement",
}
